export default __webpack_public_path__ + "static/media/09.dda94349.jpg";